import { render, staticRenderFns } from "./BpBrandGroup.vue?vue&type=template&id=a40694f6&scoped=true"
import script from "./BpBrandGroup.vue?vue&type=script&lang=js"
export * from "./BpBrandGroup.vue?vue&type=script&lang=js"
import style0 from "./BpBrandGroup.vue?vue&type=style&index=0&id=a40694f6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40694f6",
  null
  
)

export default component.exports